import { useI18n, useT } from '../../lib/i18n';
import { useMoney } from '../../lib/money';
import { usePct } from './blocks';

/**
 * Özel rapor sonuçlarının ortak biçimleri (F8-08/F8-09): boyut değerinin ekrandaki adı ve metrik değeri.
 * Rapor oluşturucu ve ana panel bileşenleri kullanır.
 */

const TAGS: Record<string, string> = { tr: 'tr-TR', en: 'en-GB', de: 'de-DE', ar: 'ar' };

export function useDimLabel() {
  const t = useT();
  const { locale, formatDate } = useI18n();
  const tag = TAGS[locale] ?? 'tr-TR';
  const regions = new Intl.DisplayNames([tag], { type: 'region' });
  const month = (ym: string) =>
    new Intl.DateTimeFormat(tag, { month: 'short', year: 'numeric', timeZone: 'UTC' }).format(
      new Date(`${ym}-01T12:00:00Z`),
    );
  return (dim: string, key: string, label: string | null): string => {
    if (key === 'none') return t('admin.reports.none');
    switch (dim) {
      case 'day':
      case 'week':
        return formatDate(key, false);
      case 'month':
      case 'expiryMonth':
        return month(key);
      case 'year':
        return key;
      case 'channel':
        return t(`admin.salesReport.channels.${key}`);
      case 'segment':
        return t(`admin.salesReport.segments.${key}`);
      case 'paymentMethod':
        return t(`admin.orders.paymentMethods.${key}`);
      case 'country':
        return regions.of(key) ?? key;
      case 'customerType':
        return t(`admin.reportBuilder.customerTypes.${key}`);
      default:
        return label ?? key;
    }
  };
}

/** Metrik değeri: para (TL), adet veya yüzde (baz puan); boşsa "—". */
export function useMetricFormat() {
  const money = useMoney();
  const pct = usePct();
  const { formatNumber } = useI18n();
  return (kind: string, v: number | null) =>
    v === null ? '—' : kind === 'money' ? money(v, 'TRY') : kind === 'bps' ? pct(v) : formatNumber(v, 0);
}
